import { Alert } from "react-native";

/**
 * Shows an alert when no app updates are available
 * @param customMessage Optional custom message to display
 * @param onDismiss Optional callback to execute when alert is dismissed
 */

let isAlertShowing = false;

export function showNoUpdatesAvailableAlert(
  customMessage?: string,
  onDismiss?: () => void,
): void {
  // If an alert is already showing, don't show another one
  if (isAlertShowing || __DEV__) {
    return;
  }

  isAlertShowing = true;

  const resetFlag = (): void => {
    isAlertShowing = false;
    if (onDismiss) {
      onDismiss();
    }
  };

  const message =
    customMessage || "Your app is already running the latest version.";

  Alert.alert("No Updates Available", message, [
    {
      text: "OK",
      onPress: resetFlag,
    },
  ]);
}

/**
 * Shows an alert when an update error occurs with options to retry or cancel
 * @param errorMessage The error message to display
 * @param retryAction Function to call when user wants to retry
 * @param onCancel Optional function to call when user cancels
 */
export function showUpdateErrorAlert(
  retryAction: () => void,
  onCancel?: () => void,
): void {
  if (isAlertShowing || __DEV__) {
    return;
  }

  isAlertShowing = true;

  const resetFlag = (): void => {
    isAlertShowing = false;
  };

  const buttons = [
    {
      text: "Try Again",
      onPress: (): void => {
        resetFlag();
        retryAction();
      },
    },
    {
      text: "Cancel",
      style: "cancel" as const,
      onPress: (): void => {
        resetFlag();
        if (onCancel) onCancel();
      },
    },
  ];

  Alert.alert(
    "Update Error",
    "Something went wrong with trying to update the app.",
    buttons,
    {
      onDismiss: (): void => {
        resetFlag();
        if (onCancel) onCancel();
      },
    },
  );
}
